import MuiTypography, {TypographyProps} from '@mui/material/Typography';

/** Mui Typography Component. For full prop information see here: https://mui.com/material-ui/api/typography/  */

const Typography = (props: TypographyProps): JSX.Element => {
  return <MuiTypography {...props}>{props.children}</MuiTypography>;
};

export default Typography;
